import { callApi } from '@local_modules/generic/fetch.js'

export async function loadAppAccount (appAccountId) {
  const apiUrl = '/api/app-account/:appAccountId/details'
  const data = await callApi(apiUrl, {
    appAccountId: appAccountId || null
  })
  console.log('api data', data)

  return data
}
